import { BoxNetworkItem } from '@/box/interface'
import { getFormatMessage } from '@/utils/utils'
import { Button, Checkbox, Col, Form, Input, Radio, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import { Title } from '../../shared/Title'

export interface BoxDetailNetWanProps {
  editItem?: BoxNetworkItem
  title?: boolean
  disabled?: boolean
  onSave?: (item: BoxNetworkItem) => void
}

export const BoxDetailNetWan: React.FC<BoxDetailNetWanProps> = (
  props: BoxDetailNetWanProps
) => {
  const { title, editItem, disabled, onSave } = props
  const [wanForm] = Form.useForm<BoxNetworkItem>()
  const [wanIpSource, setWanIpSource] = useState<number>(0)
  const [loading, setLoading] = useState<boolean>(false)
  const [lanEnable, setLanEnable] = useState<boolean>(false)

  const formatMessage = getFormatMessage()
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 5 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 }
    }
  }

  const labelCol4 = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 4 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 19 }
    }
  }

  const handleWanSave = async () => {
    if (!onSave) return
    try {
      const value = await wanForm.validateFields()
      value.networkType = 1
      if (lanEnable) {
        if (!value.extra) {
          value.extra = {}
        }
        value.extra.lanEnable = lanEnable
        value.lanIp = value.extra.lanIp
      }
      setLoading(true)
      await onSave(value)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (editItem) {
      wanForm.setFieldsValue(editItem)
      setWanIpSource(editItem.ipSource || 0)
      setLanEnable(editItem.extra?.lanEnable || false)
    }
  }, [editItem])

  return (
    <Form {...formItemLayout} form={wanForm} labelAlign='right'>
      {title && (
        <Title
          level={4}
          extra={
            <Button
              type='primary'
              disabled={disabled}
              loading={loading}
              onClick={handleWanSave}
            >
              {formatMessage({ id: 'app.box.detail.edit.save' })}
            </Button>
          }
        >
          {formatMessage({ id: 'app.box.detail.edit.wan' })}
        </Title>
      )}
      <Row>
        <Col span={24}>
          <Form.Item name='ipSource'>
            <Radio.Group
              disabled={disabled}
              onChange={(e) => setWanIpSource(e.target.value)}
            >
              <Radio value={0}>
                {formatMessage({ id: 'app.box.ipSource.0' })}
              </Radio>
              <Radio value={1}>
                {formatMessage({ id: 'app.box.ipSource.1' })}
              </Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={8}>
          <Form.Item
            {...labelCol4}
            name='ipAddr'
            label={formatMessage({ id: 'app.box.detail.edit.ipAddr' })}
            rules={[
              {
                required: true,
                message: formatMessage({
                  id: 'app.box.detail.edit.ipAddr.message'
                })
              }
            ]}
          >
            <Input disabled={wanIpSource === 0} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name='subnetMask'
            label={formatMessage({ id: 'app.box.detail.edit.subnetMask' })}
            rules={[
              {
                required: true,
                message: formatMessage({
                  id: 'app.box.detail.edit.subnetMask.message'
                })
              }
            ]}
          >
            <Input disabled={wanIpSource === 0} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name='gateway'
            label={formatMessage({ id: 'app.box.detail.edit.gateway' })}
            rules={[
              {
                required: true,
                message: formatMessage({
                  id: 'app.box.detail.edit.gateway.message'
                })
              }
            ]}
          >
            <Input disabled={wanIpSource === 0} />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={8}>
          <Form.Item
            {...labelCol4}
            name='dns1'
            label='DNS1'
            rules={[
              {
                required: true,
                message: formatMessage({
                  id: 'app.box.detail.edit.dns1.message'
                })
              }
            ]}
          >
            <Input disabled={wanIpSource === 0} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name='dns2' label='DNS2'>
            <Input disabled={wanIpSource === 0} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name={['extra', 'lanIp']}
            label={
              <span>
                <Checkbox
                  checked={lanEnable}
                  onChange={(e) => setLanEnable(e.target.checked)}
                />
                LAN IP
              </span>
            }
          >
            <Input disabled={!lanEnable} />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}
